import http from 'conversations-http/clients/http';
export function fetchFbmInstalls({
  pageId
}) {
  return http.get(`/facebook-messenger/v1/connection/${pageId}/hydrated`);
}